var map = {
	"./menu_icon1.png": "9772",
	"./menu_icon2.png": "30fc",
	"./menu_icon3.png": "0614",
	"./menu_icon4.png": "1594",
	"./menu_icon5.png": "eaee",
	"./menu_icon6.png": "d74f",
	"./menu_icon7.png": "b5a6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d569";